import React, { memo, useState, useEffect } from "react";
import IconButton from "../../../shared/components/IconButton";
import SVG from "react-inlinesvg";
import { useRouteMatch } from "react-router-dom";
import styles from "./header.module.scss";
import { useTranslation } from "react-i18next";
import {
  angleLeftSVG,
  sampleAvatarSVG,
  notificationSVG,
  copySVG,
  notNotificationSVG,
  logoutSVG,
  ticketsSVG,
  chatsSVG,
} from "../../../shared/helpers/icons";
import { toast } from "../../../shared/helpers/toast";
import { createTheme } from "@material-ui/core/styles";
import NotificationMenuItem from "./subComponents/NotificationMenuItem";
import Showcase from "../../../shared/components/Showcase";
import ButtonWithToolTip from "../../../shared/components/ButtonWithToolTip";
import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  ThemeProvider,
} from "@material-ui/core";
import LoaderScreen from "../../../shared/components/LoaderScreen/LoaderScreen";
import { useHistory } from "react-router-dom";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { io } from "socket.io-client";
import { webSocketEventsUrl, omuniWeb } from "../../../app/conf";
import { getAuthProfile } from "../../../app/helpers/userAuth";
import SoftPhone from "../../../sotf-phone/components/SoftPhone/Softphone";
import { COMPANIES } from "../../../shared/constants/companies";
import { Text } from "../../../shared/components";
import {
  FONT_COLOR,
  FONT_SIZE,
  FONT_WEIGHT,
} from "../../../shared/components/Text/types";
import useGetChannels from "../../hooks/useGetChannels";
import { useDispatch } from "react-redux";
import { setChannelsData } from "../../../channels/actions/channels";
import useRecaptcha from "../../../auth/hooks/useRecaptcha";
import useGetUsers from "../../../shared/hooks/users/useGetUsers";
import USER_TYPES from "../../../users/constants/user_types";
import { getUsersAndBotsSuccess, getUsersSuccess } from "../../../users/actions/users";
import { getBotsSuccess } from "../../../bots/actions/bots";

const Header = ({
  config: { goBack, title: _title, subtitle: _subTitle },
  changeConfigChildRoute,
  changeHomeTitleAndDescription,
  innerRoutes,
  location,
  loggedUser,
  getAgentStatusRequest,
  addNotification,
  setNotifications,
  socketEvents: {
    notificationSocketEvent,
    profileUpdatedSocketEvent,
  },
  notifications: { notifications = [] },
  ticketsStateSelector: {
    aggentAssistance: { error },
  },
  company: { company },
  getAreasRequest,
  signOut,
  getCompanyRequest,
  setNotificationSocketEvent,
  updateUserPermissions,
}) => {
  const { t } = useTranslation("home");
  const matchRoute = useRouteMatch(location.pathname);
  const history = useHistory();
  const [title, setTitle] = useState("");
  const [caseTitle, setCaseTitle] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [OpenMenuProfile, setOpenMenuProfile] = useState(false);
  const [openNotificationMenu, setOpenNotificationMenu] = useState(false);

  const [code, setCode] = useState("");

  const pathname = location.pathname;
 
  const useChannels = useGetChannels();

  const dispatch = useDispatch();
  const recaptcha = useRecaptcha();

  const handleClickNotificationMenu = () => {
    setOpenNotificationMenu(!openNotificationMenu);
  };

  const handleCloseNotificationMenu = () => {
    setOpenNotificationMenu(false);
  };

  const updateNotificationsAllRead = () => {
    const socket = io(webSocketEventsUrl, { transports: ["websocket"] });
    socket.emit(
      "markAllAsRead",
      { userId: loggedUser.crmUserId },
      (error, history) => {
        if (error) {
          console.error(error);
        } else {
          if (history) {
            let historyNotificationsLength = 0;
            history.forEach((redisEvent) => {
              if (redisEvent.event === "notification") {
                historyNotificationsLength = +1;
              }
            });
            if (historyNotificationsLength >= notifications.length) {
              history.forEach((redisEvent) => {
                if (redisEvent.event === "notification") {
                  setNotificationSocketEvent(redisEvent.data);
                }
              });
            }
          }
        }
      }
    );
  };

  const handleClickMarkAllLikeRead = () => {
    updateNotificationsAllRead();
    notifications.forEach((notification) => {
      if (!notification.read) notification.read = true;
    });
    setNotifications(notifications);
    handleCloseNotificationMenu();
  };

  const tableNotificationTheme = createTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "10px",
        },
      },
    },
  });

  //opens profile menu
  const handleOpenProfile = () => {
    setOpenMenuProfile(!OpenMenuProfile);
  };

  const handleClickAway = () => {
    setOpenMenuProfile(false);
  };

  //actions of profile menu
  const handleLogout = () => {
    signOut();
  };

  const allUsers = useGetUsers();

  useEffect(() => {
    allUsers.getUsers();
    if (loggedUser.company) {
      getCompanyRequest(loggedUser.company);
    }
  }, []);

  useEffect(() => {
    if(!allUsers.data) return;

    const humans = allUsers.data.filter(user=> user.type === USER_TYPES.HUMAN);
    const bots = allUsers.data.filter(user=> user.type === USER_TYPES.BOT);

    dispatch(getUsersSuccess(humans, humans.length))
    dispatch(getBotsSuccess(bots, bots.length));
    dispatch(getUsersAndBotsSuccess(allUsers.data));
  }, [allUsers.data])

  useEffect(() => {
    if (company) {
      setCode(company?.code);
    }
  }, [company]);

  const isCurrentRoute = (path, exact = false) =>
    exact
      ? matchRoute.path === path
      : matchRoute.path.includes(path) ||
        String(path).includes(matchRoute.path);

  useEffect(() => {
    innerRoutes.some((route) => {
      if (isCurrentRoute(route.path)) {
        changeConfigChildRoute(route);

        const child = route.innerRoutes.find(({ path }) =>
          isCurrentRoute(path, true)
        );

        setTitle(
          child && String(child.title.key).length
            ? `${t(
                code === COMPANIES.ECUADOR &&
                  (route.title.key === "cases" || route.title.key === "users")
                  ? route.title.key + "_stctea"
                  : route.title.key
              )} / ${t(
                code === COMPANIES.ECUADOR &&
                  (child.title.key === "case" || child.title.key === "users")
                  ? child.title.key + "_stctea"
                  : child.title.key
              )}`
            : t(
                code === COMPANIES.ECUADOR &&
                  (route.title.key === "cases" || route.title.key === "users")
                  ? route.title.key + "_stctea"
                  : route.title.key
              )
        );
        return true;
      }

      return false;
    });
  }, [location, innerRoutes, changeConfigChildRoute, t, code]);

  useEffect(() => {
    return () => {
      changeHomeTitleAndDescription();
    };
  }, [changeHomeTitleAndDescription]);

  useEffect(() => {
    getAreasRequest();
    setNotifications([]);
    useChannels.get();
    recaptcha.cleanupScript();

    //use the data saved into localstorage, if this exists
    const localStorageChannels = localStorage.getItem("channels");

    if(localStorageChannels) return dispatch(setChannelsData(JSON.parse(localStorageChannels))); 
  }, []);

  useEffect(() => {
    if(!useChannels.data) return;

    dispatch(setChannelsData(useChannels.data));

    //set channels data to localsotrage
    localStorage.setItem("channels", JSON.stringify(useChannels.data));
  }, [useChannels.data])

  useEffect(() => {
    window.onbeforeunload = () => {
      changeHomeTitleAndDescription();
    };
  }, [changeHomeTitleAndDescription]);

  useEffect(() => {
    if (error) {
      setOpenLoader(false);
    }
  }, [error]);

  useEffect(() => {
    if (profileUpdatedSocketEvent) {
      const profileCode = "administrator";
      const { authEntities, authRole } = getAuthProfile(profileCode);

      updateUserPermissions({
        permisionEntities: authEntities,
        permission: authRole,
      });
    }
  }, [profileUpdatedSocketEvent]);

  useEffect(() => {
    if (loggedUser.agentCode) {
      getAgentStatusRequest();
    }
  }, [loggedUser.agentCode]);

  useEffect(() => {
    if (_title && _title.includes("Casos /")) {
      setCaseTitle(true);
    } else {
      setCaseTitle(false);
    }
  }, [_title]);

  //add type socket verification
  useEffect(() => {
    if (
      notificationSocketEvent &&
      Object.keys(notificationSocketEvent).length > 0
    )
      addNotification(notificationSocketEvent);
  }, [notificationSocketEvent]);

  const copyCaseNumber = (e, caseNumber) => {
    e.preventDefault();
    e.stopPropagation();
    let copiedCaseNumber = caseNumber.slice(7);
    navigator.clipboard.writeText(copiedCaseNumber);
    toast(t("home:ticket_number_copied"), "success");
  };

  const handleGoBack = () => {
    history.goBack();
  };

  const handleNavigateToCases = () => {
    if (pathname.includes("tickets/")) {
      const id = pathname.split("/")[2];
      const url = `${omuniWeb}/chats/?chatId=${id}`;
      window.location.href = url;
      return
    }
    const url = `${omuniWeb}/chats`;
    window.location.href = url;
  };

  const pageCases = pathname.includes("tickets");
  
  return (
    <div className={styles.container}>
      <div className={styles.arrowAndTitle}>
        {!!goBack && (
          <div className={styles.icon}>
            <div onClick={handleGoBack}>
              <IconButton>
                <SVG src={angleLeftSVG} />
              </IconButton>
            </div>
          </div>
        )}
        <div className={styles.header}>
          <div className={styles.content}>
            <div className={styles.titleContent}>
              {caseTitle ? (
                <span
                  className={styles.title}
                  onClick={(e) => copyCaseNumber(e, _title)}
                >
                  <Text
                    value={_title || title}
                    fontColor={FONT_COLOR.OTHERS.GRAY_LIGHT}
                    fontSize={FONT_SIZE.LG}
                    fontWeight={FONT_WEIGHT.BOLD}
                  />
                  <SVG title={t("home:copy")} src={copySVG} />
                </span>
              ) : (
                <Text
                  value={_title || title}
                  fontColor={FONT_COLOR.OTHERS.GRAY_LIGHT}
                  fontSize={FONT_SIZE.LG}
                  fontWeight={FONT_WEIGHT.BOLD}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.softPhoneContainer}>
        {loggedUser.agentType &&
          loggedUser.agentType.toLowerCase() === "webrtc" &&
          loggedUser?.webRTC &&
          loggedUser.webRTC.domain &&
          loggedUser.webRTC.user &&
          loggedUser.webRTC.password && (
            <SoftPhone
              username={loggedUser.name}
              credentials={loggedUser.webRTC}
            />
          )}
      </div>
      <div className={styles.agentContainer}>

        {pageCases && (
          <divh className={styles.switch}>

            <div className={styles.chatsWrapper}>
              <ButtonWithToolTip
                title={t("home:change_to_chats")}
                placement="down"
                className={styles.svgStyles}
                icon={chatsSVG}
                onClick={handleNavigateToCases}
              />
            </div>
            <div className={styles.ticketsWrapper}>
              <ButtonWithToolTip
                title={t("home:currenty_cases_view")}
                placement="down"
                className={styles.svgStyles}
                icon={ticketsSVG}
              />
            </div>
          </divh>
        )}
        <div className={styles.notificationsContainer}>
          <Badge
            badgeContent={
              notifications.length
                ? notifications.filter((notification) => !notification.read)
                    .length
                : null
            }
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            color={"primary"}
          >
            <ButtonWithToolTip
              title="Notificaciones"
              placement="right"
              onClick={handleClickNotificationMenu}
              className={styles.svgStyles}
              icon={notificationSVG}
            />
          </Badge>
          {openNotificationMenu && (
            <ClickAwayListener onClickAway={handleCloseNotificationMenu}>
              <div className={styles.notificationMenuDropdown}>
                <TableContainer>
                  <ThemeProvider theme={tableNotificationTheme}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableBody>
                        {notifications.length ? (
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                            onClick={handleClickMarkAllLikeRead}
                          >
                            <TableCell colSpan={3} align="right">
                              <div
                                className={styles.notificationHeaderContainer}
                              >
                                <div className={styles.notificationTitle}>
                                  {t("home:notifications")}
                                </div>
                                <div className={styles.markLikeRead}>
                                  {t("home:mark_like_read")}
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ) : (
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                            onClick={handleClickMarkAllLikeRead}
                          >
                            <TableCell colSpan={3} align="right">
                              <Showcase
                                image={notNotificationSVG}
                                description={t("home:no_notifications_yet")}
                              />
                            </TableCell>
                          </TableRow>
                        )}
                        {notifications.map((notification) => (
                          <NotificationMenuItem
                            notification={notification}
                            history={history}
                            handleCloseNotificationMenu={
                              handleCloseNotificationMenu
                            }
                          />
                        ))}
                      </TableBody>
                    </Table>
                  </ThemeProvider>
                </TableContainer>
              </div>
            </ClickAwayListener>
          )}
        </div>
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className={styles.profileDropdown}>
            <button onClick={(e) => handleOpenProfile(e)}>
              <div className={styles.dropDownContainer}>
                {loggedUser.picture ? (
                  <img
                    className={styles.profilePicture}
                    src={loggedUser.picture}
                  />
                ) : (
                  <SVG
                    className={styles.profilePicture}
                    src={sampleAvatarSVG}
                    title="Online"
                  />
                )}
              </div>
            </button>
            {OpenMenuProfile && (
              <div className={styles.menuDropdown}>
                <div className={styles.AccountWrapper}>
                  <div className={styles.TitleAccountWrapper}>
                    <Text
                      value="Cuenta"
                      fontSize={FONT_SIZE.SM}
                      fontWeight={FONT_WEIGHT.SEMI_BOLD}
                      fontColor={FONT_COLOR.SECONDARY}
                    />
                  </div>
                  <div className={styles.AccountContentWrapper}>
                    {loggedUser.picture ? (
                      <img
                        className={styles.profilePicture}
                        src={loggedUser.picture}
                      />
                    ) : (
                      <SVG
                        className={styles.profilePicture}
                        src={sampleAvatarSVG}
                        title="Online"
                      />
                    )}

                    <div className={styles.NameAndProfileWrapper}>
                      <Text
                        value={`${loggedUser.name} ${loggedUser.lastName}`}
                        fontSize={FONT_SIZE.SM}
                        fontWeight={FONT_WEIGHT.SEMI_BOLD}
                        fontColor={FONT_COLOR.SECONDARY}
                      />
                      <Text
                        value={loggedUser.email}
                        fontColor={FONT_COLOR.SECONDARY}
                        fontSize={FONT_SIZE.XXS}
                      />
                      <Text
                        value={t(
                          `selectors:${loggedUser.profiles.toLowerCase()}`
                        )}
                        fontColor={FONT_COLOR.SECONDARY}
                        fontSize={FONT_SIZE.XXS}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.separator}></div>
                <div onClick={handleLogout} className={styles.lastMenuItem}>
                  <SVG src={logoutSVG} />

                  <Text
                    value={t("home:sign_out")}
                    fontColor={FONT_COLOR.SECONDARY}
                    fontSize={FONT_SIZE.XXS}
                  />
                </div>
              </div>
            )}
          </div>
        </ClickAwayListener>
      </div>
      {openLoader && (
        <LoaderScreen
          open={openLoader}
          text={t("attendding_call")}
          textClassName={styles.textLoader}
        />
      )}
    </div>
  );
};

export default memo(Header);
